import { useState, useEffect } from 'react';
import { loadDemoStatuses } from '../demo/demoData';

function useHoneytokensStatuses() {
  const [honeytokensStatuses, setHoneytokensStatuses] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchStatuses = async () => {
    try {
      const data = await loadDemoStatuses('honeytokens');
      setHoneytokensStatuses(data || {});
    } catch (err) {
      setError('Failed to fetch honeytoken statuses: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStatuses();
  }, []);

  const updateStatus = async (honeytokenName, enabled, userName = null) => {
    setLoading(true);
    try {
      setHoneytokensStatuses(prev => ({
        ...prev,
        [honeytokenName]: { ...(prev[honeytokenName] || {}), enabled }
      }));
      return true;
    } catch (err) {
      setError(`Failed to ${enabled ? 'enable' : 'disable'} ${honeytokenName}${userName ? ` for user ${userName}` : ''}: ${err.message}`);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { 
    honeytokensStatuses,
    loading, 
    error, 
    updateStatus,
    refreshStatuses: fetchStatuses 
  };
}

export default useHoneytokensStatuses; 